import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { useAuth } from '@/contexts/AuthContext';

export function HomePage() {
  const { currentUser } = useAuth();

  return (
    <Layout wide>
      <div className="home">
        {/* Hero */}
        <header className="hero">
          <p className="hero-subtitle">GRID Support Portal · v1.0</p>
          <h1 className="hero-title">GRID Services <span className="accent">Support</span></h1>
          <div className="hero-copy">
            <span>Request services, report issues, and track support tickets in one place.</span>
            <span>Multi-channel — reach us on web, Telegram, or Discord.</span>
            <span className="hero-copy--highlight">Affiliate program — earn RLUSD for every referral you bring to GRID.</span>
          </div>
          <div className="hero-statusbar">
            <span className="status-chip">Network <strong>XRPL Mainnet</strong></span>
            <span className="status-chip">Status <strong>System Ready</strong></span>
            <span className="status-chip">Channel <strong>Web</strong></span>
          </div>
        </header>

        <div className="home-cards">
          {/* Actions */}
          <div className="terminal-card">
            <div className="card-header">
              <span className="card-title">Quick Actions</span>
            </div>
            <div className="card-body">
              {currentUser ? (
                <div className="btn-row">
                  <Link to="/tickets/new" className="action-btn large">Create Ticket</Link>
                  <Link to="/tickets" className="action-btn large secondary">My Tickets</Link>
                  <Link to="/affiliates" className="action-btn large secondary">Affiliates</Link>
                </div>
              ) : (
                <div className="btn-row">
                  <Link to="/login" className="action-btn large">Sign In</Link>
                  <Link to="/login?signup=1" className="action-btn large secondary">Create Account</Link>
                </div>
              )}
            </div>
          </div>

          {/* Affiliate highlight */}
          <div className="terminal-card">
            <div className="card-header">
              <span className="card-title">Affiliate Program</span>
              <div className="card-header-right">
                <span className="stat-chip">Reward <strong>RLUSD</strong></span>
              </div>
            </div>
            <div className="card-body">
              <div className="hero-copy">
                <span className="hero-copy--highlight">Earn with GRID Affiliates.</span>
                <span>Get your referral code and earn on the business you bring to GRID.</span>
                <span>Paid in RLUSD directly to your XRPL wallet — free to join.</span>
              </div>
              <div className="hero-statusbar">
                <span className="status-chip">Cost <strong>Free</strong></span>
                <span className="status-chip">Payment <strong>RLUSD</strong></span>
                <span className="status-chip">Network <strong>XRPL</strong></span>
              </div>
              {currentUser ? (
                <Link to="/affiliates" className="action-btn large">Get My Code</Link>
              ) : (
                <Link to="/affiliate-program" className="action-btn large">View the Program</Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
